/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { navigateToError } from '@utils';
import { FormType } from '@constants/forms';
import ExpandableTable from '@components/InfringementExtension/ExpandableTable/ExpandableTable';
import { iObligation } from '@interfaces/interfaces';
import { iInfringementExtensionFormValues } from '@services/InfringementExtensionService';
import { getObligationOptions } from '@api';
import styles from './InfringementExtStep5.module.scss';

function InfringementExtStep5(): ReactElement {
  const [loading, setLoading] = useState(false);
  const context = useFormikContext();
  const { values }: { values: iInfringementExtensionFormValues } = useFormikContext();

  const [authorisedOb, setObligationDetails] = useState({} as iObligation);
  const [eligibleObs, setEligibleObligations] = useState([] as iObligation[]);
  const [ineligibleObs, setIneligibleObligations] = useState([] as iObligation[]);
  useEffect(() => {
    try {
      const obNumFormIk = values.OBLIGATION_NUMBER;
      if (values.OBLIGATION_NUMBER) {
      getObligationOptions(obNumFormIk, FormType.INFRINGEMENTEXTENSION)
        .then((responseBody) => {
          if (responseBody && responseBody?.Authorised) {
            setObligationDetails(responseBody?.Authorised);
            context.setFieldValue('AuthorisedObligation', responseBody?.Authorised);
            context.setFieldValue('InfringementNoticeNumber', responseBody?.Authorised.InfringementNumber);
          }
          if (responseBody && responseBody?.Obligations && responseBody?.IneligibleObligations) {
            setEligibleObligations(responseBody?.Obligations);
            setIneligibleObligations(responseBody?.IneligibleObligations);
            context.setFieldValue('EligibleObligations', responseBody?.Obligations);
            context.setFieldValue('IneligibleObligations', responseBody?.IneligibleObligations);
          }
        })
        .catch((e) => console.log(e));
      setLoading(false);
      }
    } catch (ex) {
      navigateToError();
    }
    return () => {
      setLoading(false);
    };
  }, [values.OBLIGATION_NUMBER]);

  return (
    <>
      {!loading && (
        <>
          <div className="vfH2">Your fines</div>
          <p>You are applying for an infringement extension for the following fine(s):</p>
          <div className={styles.offenceDetails}>
            <div className={styles.detailHeadings}>
              {authorisedOb.Number && <span>Obligation #</span>}
              {authorisedOb.OffenceDate && <span>Offence Date</span>}
              {authorisedOb.OffenceDesc && <span>Offence Description</span>}
              {authorisedOb.AmountDue && <span>Amount</span>}
            </div>
            <div className={styles.detailValues}>
              {authorisedOb.Number && <span className={styles.obligationNumber}>{authorisedOb.Number}</span>}
              {authorisedOb.OffenceDate && <span>{authorisedOb.OffenceDate}</span>}
              {authorisedOb.OffenceDesc && <span>{authorisedOb.OffenceDesc}</span>}
              {authorisedOb.AmountDue && <span>${authorisedOb.AmountDue}</span>}
            </div>
            <div className={styles.detailTable}>
              <table className={styles.offenceTable}>
                <tbody>
                  {
                  authorisedOb.Number && (
                  <tr className={styles.onlyMobileRows}>
                    <td className={styles.tdFirstColBackground}>Obligation #</td>
                    <td className={styles.tdSecondColBackground}>{authorisedOb.Number}</td>
                  </tr>
                  )
                  }
                  {
                  authorisedOb.OffenceDate && (
                  <tr className={styles.onlyMobileRows}>
                    <td className={styles.tdFirstColBackground}>Offence Date</td>
                    <td className={styles.tdSecondColBackground}>{authorisedOb.OffenceDate}</td>
                  </tr>
                  )
                  }
                  {
                  authorisedOb.OffenceDesc && (
                  <tr className={styles.onlyMobileRows}>
                    <td className={styles.tdFirstColBackground}>Offence Description</td>
                    <td className={styles.tdSecondColBackground}>{authorisedOb.OffenceDesc}</td>
                  </tr>
                  )
                  }
                  {
                  authorisedOb.AmountDue && (
                  <tr className={styles.onlyMobileRows}>
                    <td className={styles.tdFirstColBackground}>Amount</td>
                    <td className={styles.tdSecondColBackground}>${authorisedOb.AmountDue}</td>
                  </tr>
                  )
                  }
                  {
                  authorisedOb.OffenceLocation && (
                  <tr className={styles.hideInMobileView}>
                    <td>Offence Location</td>
                    <td className={styles.uppcaseText}>{authorisedOb.OffenceLocation}</td>
                  </tr>
                  )
                  }
                  {
                  authorisedOb.OffenceTime && (
                  <tr className={styles.hideInMobileView}>
                    <td>Time of Offence</td>
                    <td>{authorisedOb.OffenceTime}</td>
                  </tr>
                  )
                  }
                  {
                  authorisedOb.Registration && (
                  <tr className={styles.hideInMobileView}>
                    <td>Vehicle Registration</td>
                    <td>{authorisedOb.Registration}</td>
                  </tr>
                  )
                  }
                  {
                  authorisedOb.OffenceLocation && (
                  <tr className={styles.onlyMobileRows}>
                    <td colSpan={2}>
                      Offence Location <br /> <span className={styles.tdSpanFont}>{authorisedOb.OffenceLocation}</span>
                    </td>
                  </tr>
                  )
                  }
                  {
                  authorisedOb.OffenceTime && (
                  <tr className={styles.onlyMobileRows}>
                    <td colSpan={2}>
                      Time of Offence <br /> <span className={styles.tdSpanFont}>{authorisedOb.OffenceTime}</span>
                    </td>
                  </tr>
                  )
                  }
                  {
                  authorisedOb.Registration && (
                  <tr className={styles.onlyMobileRows}>
                    <td colSpan={2}>
                      Vehicle Registration <br /> <span className={styles.tdSpanFont}>{authorisedOb.Registration}</span>
                    </td>
                  </tr>
                  )
                  }
                </tbody>
              </table>
            </div>
            {eligibleObs.length !== 0 && (
              <>
                <p>
                  <strong>
                    Are there any other fines you were not aware of? If so, please select from the list below. Please note, if you do not deal with your outstanding fines,
                    enforcement action may continue.
                  </strong>
                </p>
                <ExpandableTable obligations={eligibleObs} inactiveRows={false} />
              </>
            )}
            <br />
            {ineligibleObs.length !== 0 && (
              <>
                <p>
                  <strong>
                    You also have the following matters, which are not eligible for an infringement extension (for information on eligibility, visit
                    {' '}
                    <a href="/Your-options/infringement-extension" target="_blank" rel="noreferrer">
                      infringement extension
                    </a>
                    ). If you
                    do not deal with your outstanding fines, enforcement action may continue. For information on the options available to you, visit your options or call Fines
                    Victoria{' '}03 9200 8111{' '}(1300 369 819{' '}for regional callers).{' '}
                  </strong>
                </p>
                <ExpandableTable obligations={ineligibleObs} inactiveRows />
              </>
            )}
            <p className={styles.middleNoteSection}>This summary may not be a complete list of your fines, as this can vary as a result of a difference in:</p>
            <div>
              <ul>
                <li>the spelling of your name</li>
                <li>your address</li>
                <li>your driver licence number</li>
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default InfringementExtStep5;
